import { render, staticRenderFns } from "./ScopeThreeEmissionByCategory.vue?vue&type=template&id=36e8f39a"
import script from "./ScopeThreeEmissionByCategory.vue?vue&type=script&lang=js"
export * from "./ScopeThreeEmissionByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports